<template>
    <div>
        <div
            class="toast qg-consent qg-consent-initial consent-toast hidden"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
            data-animation="false"
        >
            <div class="toast-header bg-info text-white">
                <strong class="mr-auto">{{ textTitle }}</strong>
            </div>
            <div class="toast-body p-10 text-left">
                <p>
                    {{ textLineA }}
                </p>
                <p class="d-inline" v-html="textLineB"></p>
                <p class="d-block" v-html="textLineC"></p>
                <p class="no-margin text-right">
                    <button class="btn btn-info btn-lg qg-consent-no" data-dismiss="toast" @click="consentNoClick">
                        {{ textNoBtn }}
                    </button>
                    <button class="btn btn-info btn-lg qg-consent-ok" data-dismiss="toast" @click="giveConsent">
                        {{ textYesBtn }}
                    </button>
                </p>
                <div class="clearfix"></div>
            </div>
        </div>

        <div
            class="toast qg-consent qg-consent-dismiss hidden"
            role="alert"
            aria-live="assertive"
            aria-atomic="true"
            data-autohide="false"
            data-animation="false"
        >
            <div class="toast-header bg-info text-white">
                <strong class="mr-auto">{{ textTitle }}</strong>
            </div>
            <div class="toast-body p-10 text-left">
                <p>
                    {{ textLineReject }}
                </p>
                <p class="no-margin text-right">
                    <button class="btn btn-info btn-lg qg-consent-back" data-dismiss="toast" @click="consentBackClick">
                        {{ textBackBtn }}
                    </button>
                    <button
                        class="btn btn-info btn-lg qg-consent-no qg-consent-reject"
                        @click="consentRejectClick"
                        data-dismiss="toast"
                    >
                        {{ textAcceptBtn }}
                    </button>
                </p>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>

<script>
import { globalLogger } from '../../../../helper/global-logger';
import { satGlobals } from '../../../../sat/helper/sat-globals';
import { cookieHelper } from '../../../../helper/cookie';
import { translate } from '../../../../helper/translate';
import 'bootstrap/js/dist/toast';
import { userManager } from '../../../../../lib-sat/user/user-manager';

export default {
    name: 'Consent',
    mounted() {
        this.textLineC = this.textLineC.replace('%PROJECT%', satGlobals.getProjectName);
        this.textLineC = this.textLineC.replace('%PRIVACY_URL%', satGlobals.getPrivacyUrl);
        this.textLineB = this.textLineB.replace('%AD_TECH_URL%', satGlobals.getAdTechUrl);
        this.textLineReject = this.textLineReject.replace('%PROJECT%', satGlobals.getProjectName);

        this.init();
    },
    methods: {
        async init() {
            let qgShowConsent = false;
            let qgConsentConfig = {
                eu: false,
                cookieDomain: satGlobals.getCookieDomain(),
                showConsent: qgShowConsent,
            };

            const user = await userManager.getUser();

            if (this.countries.includes(user?._rawMeData?.extra?.country)) {
                if (cookieHelper.isCookieSet('qg_consent_rejected')) {
                    return;
                }

                if (cookieHelper.isCookieSet('qg_consent')) {
                    return;
                }

                if (!cookieHelper.isCookieSet('qg_consent')) {
                    $('.qg-consent-initial').toast('show');
                    qgShowConsent = true;
                }

                qgConsentConfig = {
                    eu: true,
                    cookieDomain: satGlobals.getCookieDomain(),
                    showConsent: qgShowConsent,
                };
            }

            try {
                this.initBox(qgConsentConfig);
            } catch (e) {}
        },
        initBox(config) {
            if (config.showConsent === true) {
                globalLogger.log('consent shown');
            }

            var cookieDomain = null;

            if (config.cookieDomain) {
                cookieDomain = config.cookieDomain;
            }

            if (this.hasConsent() === true) {
                return;
            }

            if (config.eu === false) {
                this.setConsentCookie(cookieDomain);
            }
        },
        giveConsent() {
            globalLogger.log('consent given');
            this.setConsentCookie();
            document.cookie = 'qg_consent_rejected= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
        },
        setRejectCookie() {
            var maxAgeReject = 1209600;

            document.cookie = 'qg_consent= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
            if (this.cookieDomain) {
                document.cookie =
                    'qg_consent_rejected=true; max-age=' + maxAgeReject + '; secure; path=/;domain=' + this.cookieDomain;
            } else {
                document.cookie = 'qg_consent_rejected=true; max-age=' + maxAgeReject + '; secure; path=/;';
            }
        },
        setConsentCookie() {
            // 1 year
            var maxAge = 31557600;

            if (this.cookieDomain) {
                document.cookie = 'qg_consent=true; max-age=' + maxAge + '; secure; path=/;domain=' + this.cookieDomain;
            } else {
                document.cookie = 'qg_consent=true; max-age=' + maxAge + '; secure; path=/;';
            }
        },
        hasConsent() {
            return document.cookie.indexOf('qg_consent=') >= 0;
        },
        consentNoClick() {
            $('.qg-consent-initial').toast('hide');
            $('.qg-consent-dismiss').toast('show');
        },
        consentRejectClick() {
            globalLogger.log('consent rejected');

            $('.qg-consent-initial').toast('hide');
            $('.qg-consent-dismiss').toast('hide');

            this.setRejectCookie();
        },
        consentBackClick() {
            $('.qg-consent-initial').toast('show');
            $('.qg-consent-dismiss').toast('hide');
        },
    },
    data() {
        return {
            textTitle: translate('European Cookie Law'),
            textLineA: translate('This website uses own and third party cookies to develop statistical information.'),
            textLineB: translate(
                'Allowing these will personalize your experience, show custom advertising, and share browsing analysis with <a class="font-weight-bold text-info" href="%AD_TECH_URL%">third party vendors</a>.'
            ),
            textLineC: translate(
                'By using %PROJECT%, you agree to our <a class="font-weight-bold text-info" href="%PRIVACY_URL%">use of cookies</a>.'
            ),
            textLineReject: translate(
                'By enabling all cookies and interest-based advertisement, you actively support %PROJECT%. You selected to show only non-personalized ads and set technically necessary cookies.'
            ),
            textYesBtn: translate('Yes'),
            textNoBtn: translate('No'),
            textAcceptBtn: translate('Ok'),
            textBackBtn: translate('Back'),
            cookieDomain: satGlobals.getCookieDomain(),
            countries: [
                'AT',
                'BE',
                'CH',
                'HR',
                'BG',
                'CY',
                'CZ',
                'DK',
                'EE',
                'FI',
                'FR',
                'DE',
                'GR',
                'HU',
                'IE',
                'IT',
                'LV',
                'LT',
                'LU',
                'MT',
                'NL',
                'PL',
                'PT',
                'RO',
                'SK',
                'SI',
                'ES',
                'SE',
                'GB',
            ],
        };
    },
};
</script>
